import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useDropOffApi from "../api/DropOffApi";

function LegalNavbar({ renderLink, setNavClick }) {
    const navigate = useNavigate();
    const { GetDropOffCount } = useDropOffApi();
    const role = sessionStorage.getItem("Role");

    useEffect(() => {
        if (role === "Employee") {
            GetDropOffCount();
        }
    }, [role]);

    const userAccess = sessionStorage.getItem("Features");
    const features = userAccess ? JSON.parse(userAccess) : [];

    return (
        <div>
            {features.length > 0 && features
                .filter(category => 
                    !(category.description === "Settings" && (role === "Employee" || role === "Superadmin" || role === "Support"))
                )
                .map((category) => (
                    <div key={category.sectionID}>
                        {category.description !== "Drop Off" && (
                            (role === "Employee" || 
                            (role === "Superadmin" || role === "Support" && category.description === "Cash Management")) ? (
                                <div className="Title">{category.description}</div>
                            ) : (
                                role === "Arz" && (
                                    <div className="Title">{category.description}</div>
                                )
                            )
                        )}

                        {category.description !== "Drop Off" ? (
                            category.features?.map((feature) => (
                                <div key={feature.featureID}>
                                    {renderLink(feature.description, feature.slug)}
                                </div>
                            ))
                        ) : (
                            role === "Employee" && (
                                <div className="btn_container">
                                    <div className="btn-sub">
                                        <button
                                            className="dropOff"
                                            onClick={() => navigate('/dropOff')}
                                        >
                                            Drop Off
                                        </button>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                ))}
        </div>
    );
}

export default LegalNavbar;
